import $ from 'jquery';
import select2 from 'select2';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/datepicker';
import '../date-select/jquery.datepicker.extension.range.min.js';
import moment from 'moment';
import FilterNew from './Filter.js';

const newFilter = (component) => {
  if (!component) {
    return null;
  }

  const filterForm = component.querySelector('form');
  const resetButton = component.querySelector('[data-filter="reset"]');
  const selectElements = Array.from(component.querySelectorAll('.select'));
  const calendarElements = Array.from(component.querySelectorAll('[data-component="calendar"]'));

  const instance = new FilterNew(component);

  const resultReset = () => {
    filterForm.reset();

    selectElements.forEach((selectEl) => {
      const selectItem = selectEl.querySelector('select');
      const firstOptionValue = selectItem.options[0].value;
      $(selectItem).val(firstOptionValue).trigger('change');
    });

    calendarElements.forEach((calendarEl) => {
      const datePicker = calendarEl.querySelector('[data-calendar="date-picker"]');
      const dateStart = calendarEl.querySelector('[data-calendar="start-day"]');
      const dateEnd = calendarEl.querySelector('[data-calendar="end-day"]');
      const serviceDateData = calendarEl.querySelector('[data-calendar="service-date-data"]');
      const currentDay = moment().format('DD.MM.YYYY');

      dateEnd.innerText = '';
      dateStart.innerText = currentDay;
      serviceDateData.value = currentDay;
      $(datePicker).datepicker('option', { minDate: null, maxDate: null });
      $(datePicker).datepicker('setDate', new Date());
    });
  };

  resetButton.addEventListener('click', () => {
    resultReset();
  });

  const setOptionCheckValue = (id, value) => {
    const checkbox = filterForm.querySelector(`input[type="checkbox"]#${id}`);
    if (!checkbox) {
      return false;
    }

    const label = checkbox.parentElement.querySelector('label');

    checkbox.checked = value;
    checkbox.dispatchEvent(new Event('change'));

    if (label) {
      label.classList.toggle('events-options__option-label--checked');
    }

    return true;
  };

  return {
    instance,
    setOptionCheckValue,
    resultReset,
  };
};

const mountNewFilter = () => {
  const element = document.querySelector('#new-filter');

  if (element) {
    newFilter(element);
  }
};

export default mountNewFilter;
export { newFilter };
